module.exports = __webpack_public_path__ + "assets/img/kv-df4d6791.jpg";